export const Quiz = {
	Question: 'Pregunta {{currentQuestion}}',
	'Question of': 'Pregunta {{currentQuestion}} de {{totalQuestions}}',
	Answer: 'Responder',
	Saving: 'Guardando...',
	'Saving...': 'Guardando...',
	'Click on the Finish button to see the score of the quiz.':
		'Haz clic en el botón Finalizar para calificar tu evaluación.',
	'Finish quiz': 'Finalizar',
	'Quiz result': 'Resultados de la evaluación',
	'Passed exam': 'Aprobado',
	'Failed exam': 'Reprobado',
	'Total Questions': 'Cantidad de preguntas',
	Correct_one: 'Correcta',
	Correct_other: 'Correctas',
	Incorrect_one: 'Incorrecta',
	Incorrect_other: 'Incorrectas',
	Unanswered: 'Sin responder',
	Unanswered_other: 'Sin responder',
	'No answer recorded': 'No se registró respuesta para esta pregunta.',
	'% of Correct': '% de correctas',
	Score: 'Puntaje',
	Next: 'Siguiente',
	'This quiz has a time limit to answer, after that it will finish automatically.':
		'Esta prueba tiene un límite de tiempo para responder, luego de eso terminará automáticamente.',
	'Start your quiz': 'Comienza la prueba',
	'Time end': 'Se acabó el tiempo',
	minutes: 'minutos',
	Retry: 'Reintentar',
	'Retry confirm title': '¿Reiniciar la prueba?',
	'Retry confirm text':
		'Tu nota actual ({{score}}%) se borrará y comenzarás un nuevo intento desde cero.',
	'Retry confirm yes': 'Sí, reintentar',
	'Retry confirm cancel': 'Cancelar',
	'Time end calculating': 'Tiempo agotado, calculando resultado…',
	'Error saving the quiz.': 'Ocurrió un error al guardar la prueba.',
	'Answer save error title': 'Hubo un problema',
	'Answer save error text':
		'No pudimos guardar tu respuesta. Por favor intenta nuevamente.',
	'Answer save persistent error title': 'El problema persiste',
	'Answer save persistent error text':
		'Seguimos sin poder guardar tu respuesta. Por favor intenta más tarde.',
	Understood: 'Entendido',
	Paused: 'Pausado',
	'Face ID required': 'Validación de identidad requerida',
	'Face ID alert title': 'Atención: Esta prueba requiere cámara',
	'Face ID alert text':
		'Antes de empezar, verifica que tu celular o computador tenga cámara. Durante la evaluación deberás tomarte una foto de tu rostro. Importante: Si no tomas la foto, la prueba se cerrará.',
	'Validator not configured':
		'Tu organización no tiene configurada validación biométrica para este examen. Contacta al administrador.',
	'Face ID init failed':
		'No se pudo iniciar la validación de identidad. Intenta nuevamente.',
	'Back to course': 'Volver al curso',
	'Face ID retry title': 'Hubo un problema con la validación',
	'Face ID retry text':
		'No se pudo completar la validación de identidad. Por favor intenta nuevamente.',
	'Attempts remaining: {{n}}': 'Intentos restantes: {{n}}',
	'Face ID attempts exceeded title': 'No pudimos validar tu identidad',
	'Face ID attempts exceeded text':
		'Por medidas de seguridad, tu evaluación ha sido cerrada. Para ayudarte a resolver esto y que puedas rendir tu prueba, por favor contacta a nuestro equipo de soporte en chat o correo {{email}}.',
	'Finishing quiz': 'Cerrando prueba…',
	'Close validation title': '¿Cerrar la validación?',
	'Close validation text':
		'Si cierras la validación se cerrará la prueba y volverás al curso. Cuando vuelvas, deberás validarte nuevamente al llegar a la misma pregunta.',
	'Yes, close': 'Sí, cerrar',
	'Continue validating': 'Continuar validando',
	Remaining: 'Restante',
	Resume: 'Resumen',
	Feedback: 'Retroalimentación',
	'Quiz feedback': 'Retroalimentación de la evaluación',
	'Go back': 'Regresar',
	'The evaluation will be reviewed by the course instructor. We will let you know once the results are available.':
		'La evaluación será revisada por el profesor del curso, te avisaremos cuando se encuentren los resultados.',
	'Face ID service problems title': 'Problemas con la validación de identidad',
	'Face ID service problems text':
		'Estamos teniendo problemas con el servicio de validación de identidad. No se descontó ningún intento. Puedes reintentar o continuar más tarde.',
	'Continue later': 'Continuar más tarde',
	'Face ID already enrolled text':
		'Ya estás registrado en la validación de identidad. Vamos a validarte nuevamente.',
	'Quiz could not be closed':
		'No pudimos cerrar tu prueba en este momento. Tus respuestas están guardadas; vuelve a entrar en unos minutos para ver tu resultado.',
};
